import { RootState } from 'shared/config/store'

export const getIsMultiSelectEnabled = (state: RootState) => state.multiSelect.isEnabled

